import { logInfo } from "../../tracing";

const _setGranted = () => ({
    'ad_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'granted',
    'analytics_storage': 'granted',
    'wait_for_update': 500
});

const _setDenied = () => ({
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied',
    'wait_for_update': 500
});

const  _consentGrantedAdStorage= (gtag) => {
    gtag('consent', 'update', _setGranted());
    logInfo('ConsentModePrivacyService update consent set to TRUE.');
}
const  _consentDeniedAdStorage= (gtag) => {
    gtag('consent', 'update', _setDenied());
    logInfo('ConsentModePrivacyService update consent set to FALSE.');
}

const setDefault = ({gtag}) => {
    gtag('consent', 'default', _setDenied());
    logInfo('ConsentModePrivacyService default consent set.');
}

const setConsent = ({accept,gtag}) => accept === true ? _consentGrantedAdStorage(gtag) : _consentDeniedAdStorage(gtag);

export default {
    setDefault,
    setConsent
}